import { Group, Text, rem } from '@mantine/core';
import { useState } from 'react';
import { RxCaretDown } from 'react-icons/rx';
import cn from 'clsx';
import { ErrorIcon } from 'src/assets';
import { DISCORD_LINK } from 'src/constants';

const errorsMapping: [string, string | React.ReactNode][] = [
  ['User rejected the request', 'User rejected the request. Please try again.'],
  /* [
    'Execution reverted for an unknown reason',
    'Transaction failed due to insufficient gas.',
  ], */
  [
    'ineligible_address_or_discord',
    <>
      You must use an active Ethereum mainnet address and have lapr role or
      above in{' '}
      <a
        href={DISCORD_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="inline"
      >
        Capricorn's Discord
      </a>{' '}
      to qualify for claiming testnet MON.
    </>,
  ],
];

export function ErrorDisplay({ children }: { children: React.ReactNode }) {
  const [isExpanded, setIsExpanded] = useState(false);

  if (!children) return null;

  const stringifiedContent = String(children);
  let replacedContent: undefined | string | React.ReactNode;
  let isReplaced = false;

  for (const [error, replacement] of errorsMapping) {
    if (stringifiedContent.toLowerCase().includes(error.toLowerCase())) {
      replacedContent = replacement;
      isReplaced = true;
      break;
    }
  }

  return (
    <Group
      gap={16}
      w="100%"
      justify="space-between"
      wrap="nowrap"
      px={16}
      py={12}
      className="rounded-[16px] border border-solid border-[#EA543C] bg-[rgba(234,84,60,0.10)]"
    >
      <Group gap={16} className="grow flex-nowrap min-w-0">
        <ErrorIcon className="w-6 h-6 shrink-0" />
        <Text
          c="#EA543C"
          style={{
            overflow: 'hidden',
            flexGrow: 1,
            maxHeight: isReplaced || isExpanded ? undefined : rem(90),
            ...(isReplaced ? {} : { hyphens: 'auto' }),
          }}
        >
          {isReplaced ? replacedContent : children}
        </Text>
      </Group>
      {!isReplaced && (
        <RxCaretDown
          onClick={() => setIsExpanded(!isExpanded)}
          size={32}
          color="#EA543C"
          className={cn(
            'cursor-pointer transition-transform shrink-0',
            isExpanded && 'rotate-180'
          )}
        />
      )}
    </Group>
  );
}
